import React from 'react';

// Red de seguridad: si algún componente revienta al renderizar, React
// desmonta TODO el árbol y el usuario ve una página en blanco sin pista
// alguna. Con este boundary la falla queda contenida a la sección y se
// muestra un mensaje con opciones para seguir. El error igual se loguea en
// consola para poder diagnosticarlo.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    // Si el usuario navega a otra ruta, limpiamos el error para que la
    // nueva pantalla se intente renderizar normalmente.
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div style={{ maxWidth: 720, margin: '3rem auto', padding: '2rem', textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>😵‍💫</div>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: 'var(--navy, #1a2640)', margin: 0 }}>
          Algo falló al mostrar esta pantalla
        </h2>
        <p style={{ color: 'var(--muted, #6c757d)', fontSize: 14, marginTop: 8 }}>
          No perdiste nada: los datos están guardados en el servidor. Probá recargar.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 18 }}>
          <button onClick={() => window.location.reload()} style={{
            padding: '8px 18px', borderRadius: 8, border: 'none',
            background: '#1a2640', color: 'white', fontSize: 13, fontWeight: 700, cursor: 'pointer',
          }}>🔄 Recargar</button>
          <button onClick={() => { window.location.href = '/'; }} style={{
            padding: '8px 18px', borderRadius: 8, border: '1px solid #dee2e6',
            background: 'white', fontSize: 13, cursor: 'pointer',
          }}>Ir al inicio</button>
        </div>
        <details style={{ marginTop: 20, textAlign: 'left', fontSize: 11, color: '#9aa1a8' }}>
          <summary style={{ cursor: 'pointer' }}>Detalle técnico</summary>
          <pre style={{ whiteSpace: 'pre-wrap', marginTop: 8 }}>{msg}</pre>
        </details>
      </div>
    );
  }
}
